import React, {

} from 'react';

import style from './ChonkyFileBrowser.module.css';

// Custom breadcrumb navbar with drop targets
const CustomNavbar = ({
	folderChain,
	handleCrumbDragOver,
	handleCrumbDragLeave,
	handleCrumbDrop,
	handleCrumbClick,
	breadcrumbDropTargetId,
}) => {

	return (
		<div className={style.customNavbar}>
			{folderChain.map((folder, idx) => {
				const isLast = idx === folderChain.length - 1;
				const isDrop = breadcrumbDropTargetId === folder.id;

				return (
					<span key={folder.id} className={style.customNavbarItemWrapper}>
						<button
							type="button"
							data-test-id={idx === 0 ? 'navbarHomeButton' : `navbarCrumb-${idx}`}
							className={`${style.customNavbarItem} ${isLast ? style.currentCrumb : ''} ${isDrop ? style.crumbDragTarget : ''}`}
							onClick={(e) => {
								handleCrumbClick(e, folder, isLast);
							}}
							onDragOver={(e) => {
								handleCrumbDragOver(e, folder);
							}}
							onDragLeave={(e) => {
								handleCrumbDragLeave(e, folder);
							}}
							onDrop={(e) => {
								handleCrumbDrop(e, folder);
							}}
							title={folder.name}
						>
							{folder.name}
						</button>
						{!isLast && <span className={style.customNavbarSeparator}>/</span>}
					</span>
				);
			})}
		</div>
	);
};

export default CustomNavbar;